import React, { createContext, useContext, useState } from "react";

const TradeContext = createContext();
export default TradeContext; // ✅ Add default export

export const useTrade = () => useContext(TradeContext);

export const TradeProvider = ({ children }) => {
  const [side, setSide] = useState("BUY");
  const [symbol, setSymbol] = useState("");
  const [quantity, setQuantity] = useState("");
  const [orderType, setOrderType] = useState("MARKET");

  const [activeTab, setActiveTab] = useState("1"); // 👈 For tabs
  const [tradePreset, setTradePreset] = useState({
    quantity: null,
    orderType: null,
    stockName: "" // 👈 Add this
  });


  return (
    <TradeContext.Provider
      value={{
        side,
        setSide,
        symbol,
        setSymbol,
        quantity,
        setQuantity,
        orderType,
        setOrderType,
        activeTab,
        setActiveTab,
        tradePreset,
        setTradePreset,
      }}
    >
      {children}
    </TradeContext.Provider>
  );
};
